import { render } from "./BalanceStatus.vue?vue&type=template&id=cf2ccfda"
import script from "./BalanceStatus.vue?vue&type=script&lang=js"
export * from "./BalanceStatus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Riman\\Web\\Alex\\ars\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__